module.exports = __webpack_public_path__ + "img/09.bd423235.png";